import { render, staticRenderFns } from "./TqTable.vue?vue&type=template&id=505a72e6&scoped=true&"
import script from "./TqTable.vue?vue&type=script&lang=js&"
export * from "./TqTable.vue?vue&type=script&lang=js&"
import style0 from "./TqTable.vue?vue&type=style&index=0&id=505a72e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505a72e6",
  null
  
)

export default component.exports